module.exports = __webpack_public_path__ + "static/cat-5-banner.8bd82bed.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/theme/videos/cat-5-banner.mp4
// module id = 370
// module chunks = 114276838955818